export default __webpack_public_path__ + "static/media/glossaryDropdown.66a8dfdb.svg";